import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Chart, ChartConfiguration, registerables } from 'chart.js';
Chart.register(...registerables)

@Component({
    selector: 'app-emissions-chart',
    templateUrl: './emissions-chart.component.html',
    styleUrls: ['./emissions-chart.component.css'],
    imports: []
})
export class EmissionsChartComponent implements OnChanges, OnDestroy {
  @Input() item: any;
  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  private chartInstance?: Chart;

  ngOnChanges(): void {
    if (this.item && Object.keys(this.item).length > 0) {
      const datasets: { data: number[]; label: string, backgroundColor: string }[] = [];
      const backgroundColors: string[] = [
        '#428bca', '#5cb85c', '#5bc0de', '#f0ad4e', '#d9534f', '#a0a9b2', '#0c9cd8'
      ];

      Object.keys(this.item.tonnage).forEach((key, idx) => {
        if (this.item.tonnage[key] > 0 && key !== 'total') {
          let title = '';
          if (key === 'no') {
            title = 'NOx';
          } else if (key === 'formaldehyde') {
            title = 'FM';
          } else if (key.length < 5) {
            title = key.toUpperCase();
          } else if (key.length >= 5) {
            title = key.charAt(0).toUpperCase() + key.slice(1);
          } else {
            title = key;
          }
          const label = `${title} (${this.item.tonnage[key]}) tons`;
          datasets.push({data: [this.item.tonnage[key]], label, backgroundColor: backgroundColors[idx % backgroundColors.length]});
        }
      });

      const chartConfig: ChartConfiguration = {
        type: 'bar',
        data: {
          labels: [''],
          datasets
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              beginAtZero: true,
              max: this.item.tonnage.total,
              stacked: true
            },
            y: {
              stacked: true
            }
          },
          plugins: {
            legend: { display: true },
            title: {
              display: true,
              text: 'Emissions tonnage estimates (based on 1500 engine hours/year)'
            },
            tooltip: { enabled: true }
          }
        }
      };

      this.chartInstance = new Chart(this.chartCanvas.nativeElement, chartConfig);
    }
  }

  ngOnDestroy(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }
}
